module.exports = __webpack_public_path__ + "static/img/img.c6f1ce0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img.png
// module id = UBpp
// module chunks = 96